import { useRouter } from "@tanstack/react-router";
import { useMemo } from "react";

import type { Task } from "@recobra/schemas/task";

import { type ContextLinkTarget, contextLinkTargets } from "./contextLinkTargets";

/** The pages of a context type a checklist item may link to, from the app's own routes. */
export const useContextLinkTargets = (contextType: Task["contextType"]): ContextLinkTarget[] => {
  const router = useRouter();
  return useMemo(
    () => contextLinkTargets(Object.values(router.routesByPath), contextType),
    [router, contextType],
  );
};
